
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 5v22h22V5zm2 2h18v18H7zm4.406 2.219S9 10.855 9 13.5c0 1.32.656 2.293 1.156 3.063.5.769.844 1.332.844 1.937 0 1.21-1.625 2.719-1.625 2.719l1.25 1.562S13 21.11 13 18.5c0-1.305-.656-2.27-1.156-3.031-.5-.762-.844-1.328-.844-1.969 0-1.285 1.594-2.719 1.594-2.719zm5 0S14 10.855 14 13.5c0 1.32.656 2.293 1.156 3.063.5.769.844 1.332.844 1.937 0 1.21-1.625 2.719-1.625 2.719l1.25 1.562S18 21.11 18 18.5c0-1.305-.656-2.27-1.156-3.031-.5-.762-.844-1.328-.844-1.969 0-1.285 1.594-2.719 1.594-2.719zm5 0S19 10.855 19 13.5c0 1.32.656 2.293 1.156 3.063.5.769.844 1.332.844 1.937 0 1.21-1.625 2.719-1.625 2.719l1.25 1.562S23 21.11 23 18.5c0-1.305-.656-2.27-1.156-3.031-.5-.762-.844-1.328-.844-1.969 0-1.285 1.594-2.719 1.594-2.719z"}})])
          )
        }
      }
    